import { useMutation } from '@tanstack/react-query'
import UserService from '../../../services/UserService'

type RemoveUserPayload = {
  organization: string
  id: string
}

export const useDeactivateUser = () => {
  // const queryClient = useQueryClient()

  return useMutation<any, Error, RemoveUserPayload>({
    mutationKey: ['deactivate-user'],
    mutationFn: ({ organization, id }) => UserService.deactivateUser(organization, id),
    // onSuccess: (_, { organization }) =>
    //   queryClient.invalidateQueries({ queryKey: ['profile-applications', organization] }),
  })
}
